import { render, staticRenderFns } from "./TopFundedCategories.vue?vue&type=template&id=29375c46&scoped=true&"
import script from "./TopFundedCategories.vue?vue&type=script&lang=js&"
export * from "./TopFundedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29375c46",
  null
  
)

export default component.exports